import React from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';
import { PermissionKey } from '../../utils/apollo/graphqlSchema';
import { appRoutes } from '../../path';
import { userRoutes } from './Users/UsersRoutes';
import { userGroupRoutes } from './UserGroups/UserGroupsRoutes';
import roleRoutes from './Roles';
import Settings from './Settings';
import SchemaRequiredRoute from '../SchemaRequiredRoute';
import RedirectRoute from '../RedirectRoute';
import Notifications from './Notifications/Notifications';
import PlanDetails from './PlanDetails';

const adminRoutes: RouteObject[] = [
  // Redirects
  {
    path: appRoutes.permission.routePrefix,
    element: (
      <RedirectRoute
        from={appRoutes.permission.routePrefix}
        to={appRoutes.permission.allUsers}
      />
    ),
  },
  {
    path: '/permission/format',
    element: (
      <RedirectRoute
        from="/permission/format"
        to={appRoutes.permission.settings}
      />
    ),
  },
  {
    element: (
      <ProtectedRoute allRequiredPermissionKeys={[PermissionKey.AdminRead]}>
        <Outlet />
      </ProtectedRoute>
    ),
    children: [
      ...userRoutes,
      {
        element: <SchemaRequiredRoute />,
        children: [
          ...userGroupRoutes,
          ...roleRoutes,
          {
            path: appRoutes.permission.settings,
            element: <Settings />,
          },
          {
            path: appRoutes.permission.notifications,
            element: <Notifications />,
          },
          {
            path: appRoutes.permission.planDetails,
            element: <PlanDetails />,
          },
        ],
      },
    ],
  },
];

export default adminRoutes;
